import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Open-top rain barrel with a water surface and short spout.
const build: (ctx: DecoBuildCtx) => void = ({ cylinder, box, seed }) => {
  const wood = shade(0x6a5a40, (rand(seed) - 0.5) * 0.1);
  const iron = shade(0x4a4a4e, (rand(seed + 1) - 0.5) * 0.06);
  const water = shade(0x3a6a7a, (rand(seed + 2) - 0.5) * 0.08);
  cylinder(0, 0, 0, 0.4, 0.42, 0.9, wood);
  cylinder(0, 0.2, 0, 0.43, 0.43, 0.06, iron);
  cylinder(0, 0.7, 0, 0.43, 0.43, 0.06, iron);
  cylinder(0, 0.82, 0, 0.36, 0.36, 0.04, water);
  box(0.42, 0.55, 0, 0.18, 0.08, 0.08, iron);
};

export default build;
